import { render, staticRenderFns } from "./SectionLoader.vue?vue&type=template&id=fe7bd0d8&scoped=true"
import script from "./SectionLoader.vue?vue&type=script&lang=js"
export * from "./SectionLoader.vue?vue&type=script&lang=js"
import style0 from "./SectionLoader.vue?vue&type=style&index=0&id=fe7bd0d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7bd0d8",
  null
  
)

export default component.exports